import App from 'features/App';
import history from 'redux/history';
import muiSTORISTheme from 'shared/themes/storis';
import React from 'react';
import store from 'redux/store';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router } from "react-router-dom";

const routes = (
	<Router history={history}>
		<MuiThemeProvider theme={muiSTORISTheme}>
			<Provider store={store}>
				<ConnectedRouter store={store} history={history}>
					<App />
				</ConnectedRouter>
			</Provider>
		</MuiThemeProvider>
	</Router>	
);

export default routes;
